<template>
   <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>loading</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important"
          variant="warning"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-container fluid v-if="this.inSession">
        <b-row>
          <b-col md="2" style="padding:0">
            <Menu/>
          </b-col>
          <b-col md="10" style="padding:0" align="center">
            <b-row>
              <b-col style="margin-left:30px;text-align:left;position:relative">         
                <template>
                  <b-dropdown left split text="language" class="language-dropdown" toggle-class="toggle-language" split-class="split-language" style="font-size: 12px;">
                    <template #button-content>
                      <img
                        :src="currentLanguageFlag"
                        style="width:28px; height:19px; border-radius:2px;"
                      >
                    </template>

                    <!-- Dropdown Items -->
                    <b-dropdown-item @click="selectLanguage('en')">
                      <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                      English
                    </b-dropdown-item>
                    <b-dropdown-item  @click="selectLanguage('fr')">
                      <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                      Français (French)
                    </b-dropdown-item>
                    <b-dropdown-item  @click="selectLanguage('de')">
                      <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                      Deutsch (German)
                    </b-dropdown-item>
                    <b-dropdown-item  @click="selectLanguage('es')">
                      <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                      Español (Spanish)
                    </b-dropdown-item>
                    <b-dropdown-item  @click="selectLanguage('it')">
                      <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                      Italiano (Italian)
                    </b-dropdown-item>
                    <b-dropdown-item @click="selectLanguage('nl')">
                      <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                      Nederlands (Dutch)
                    </b-dropdown-item>
                    <b-dropdown-item @click="selectLanguage('pt')">
                      <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                      Português (Portuguese)
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-col>
              <b-col>
                <p class="w-pagetitle" style="margin-left:20px;margin-right:20px; margin-top:10px; text-align:right;">{{ translate("library") }}</p>   
              </b-col>
            </b-row>
            <br><br>
            <h1 class="main-title"><b><span style="color: rgb(195,147,130)">WYNE</span></b><span style="color: black">LOVER</span></h1>
            <b-row class="justify-content-center" style="position:relative; top:-15px">
              <p class="t-title">{{ translate("search wine in database") }}</p>
            </b-row>
            <div style="width:90%">
              <LibrarySearch_Desktop/>
            </div>
          </b-col>
        </b-row>      
      </b-container>
      <NoAccess v-else></NoAccess>
    </div>
  </div>
</template>

<script>
  import NoAccess from '@/components/NoAccess.vue';
  import Menu from '@/components/MenuDesktop.vue';
  import {wordlist,translate_word} from '../assets/js/translate.js';

  import Users from '../Users.js';

  import LibrarySearch_Desktop from '@/components/LibrarySearch_Desktop.vue';

  export default {
    name: "Library",
    components: {
      NoAccess,
      Menu,
      LibrarySearch_Desktop,
    },
    computed : {
      inSession() {
        return this.$store.state.inSession
      },

      currentUser() {
        return this.$store.state.user
      },
      currentUserID() {
        return this.$store.state.user_id
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      },   

      currentPage() {
        return this.$store.state.current_page
      },
      previousPage() {
        return this.$store.state.previous_page
      },
    },
    data() {
      return {
        debug: false,
        isLoading: true,

        languages:[
          {text:'English',value:'en'},
          {text:'Français',value:'fr'},
          {text:'Deutsch',value:'de'},
          {text:'Español',value:'es'},
          {text:'Italiano',value:'it'},
          {text:'Nederland',value:'nl'},
          {text:'Português',value:'pt'},
        ],
      }
    }, 
    async mounted() {
      this.isLoading = false;
    },
    methods:{
      async selectLanguage(language) {
        let local_debug = false
        if (local_debug || this.debug) console.log("TastingsOverview.selectLanguage: START");
        this.$store.commit('setLanguage',language)

        let user = this.currentUser
        let user_id = this.currentUserID
        user.language = language
        await Users.update(user_id, user)
        .then(response => {
          if (local_debug || this.debug) console.log ("TastingsOverview.selectLanguage: user ",user.email," updated with response ", response)
        })
        .catch(error => {
          if (local_debug || this.debug) console.log('TastingsOverview.selectLanguage: catch await Users.update ERROR : ', error);
        })

        if (local_debug || this.debug) console.log("TastingsOverview.selectLanguage: STOP");
      },
      
      translate(string) {
        return translate_word(string, this.currentLanguage);
      },

    }
  }    
</script>

<style>
@import url("../assets/styles/wynestyle.css");
</style>